// Routes owned by the Auth module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const authPaths = {
    login: '/auth/login',
    forgot: '/auth/forgot',
} as const
